import ajaxService from "./ajax-service";
import { validationErrors } from "../utils";
class CustomerBannerService {

    async fetch(page, perpage) {
        let param = `page=${page}&perPage=${perpage}`
        const response = await ajaxService.get(`/customer-banners?${param}`);
        if (response ?? false) {
            return response;
        } else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }

    async add(data) {
        const response = await ajaxService.post(`/customer-banners`, data);
        if (response?.success ?? false) {
            return response;
        }
        else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }

    async edit(id, data) {
        const response = await ajaxService.post(`/customer-banners/${id}`, data);
        if (response?.success ?? false) {
            return response;
        }
        else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }
    async status(id) {
        const response = await ajaxService.post(`/customer-banners/${id}/toggle`);
        if (response?.success ?? false) {
            return response;
        }
        else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }

    async delete(id) {
        const response = await ajaxService.delete(`/customer-banners/`, id);
        if (response?.success ?? false) {
            return response;
        }
        else {
            const errors = response.data.errors;
            return validationErrors(errors);
        }
    }

}

const customerBannerService = new CustomerBannerService();
export default customerBannerService;
